import { render, staticRenderFns } from "./AttributeTextSelector.vue?vue&type=template&id=deb5faa4&scoped=true&"
import script from "./AttributeTextSelector.vue?vue&type=script&lang=js&"
export * from "./AttributeTextSelector.vue?vue&type=script&lang=js&"
import style0 from "./AttributeTextSelector.vue?vue&type=style&index=0&id=deb5faa4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb5faa4",
  null
  
)

export default component.exports